<style scoped>
.checkin_information_attendance {
  width: 380px;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
}

.checkin_information_attendance_top {
  width: 100%;
  height: 69px;
  line-height: 69px;
  padding-left: 20px;
  color: rgba(0, 0, 0, 0.65);
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
}

.checkin_information_attendance_content {
  flex: 1;
  overflow-y: auto;
  width: 327px;
  max-height: 470px;
  margin: 0 auto;
}

.singe2 {
  width: 100%;
  height: 42px;
}

.checkin_information_attendance_single {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 14px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #e8e8e8;
}

::v-deep .el-input__icon {
  line-height: 1.5rem;
}

.checkin_information_attendance_text {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ing {
  position: relative;
}

.ing::after {
  content: "";
  background: #21D59B;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}

.end {
  position: relative;
}

.end::after {
  content: "";
  background: #F2637B;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.no-more{
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(115, 113, 113);
  height: 300px;
}
</style>

<template>
  <div class="checkin_information_attendance">
    <div class="checkin_information_attendance_top">通行记录</div>
    <div class="checkin_information_attendance_content">
      <div v-if="attendanceList && attendanceList.length>0" v-for="item in attendanceList" :key="item.id" class="singe2">
        <div v-if="item.user"
            :class="[
                  'checkin_information_attendance_single',
                  item.status == 1 ? 'ing' : 'end',
                ]"
        >
          <div class="checkin_information_attendance_text">
            <el-tooltip class="item" effect="dark"
                        :content="item.user.name+'通过'+ modeTypeText(item.modeType)+'进入设备'+ (item?.device?.name ? (item?.device?.name) : (item.deviceSn || ''))"
                        placement="top">
              <span>{{ item.user.name }}通过{{ modeTypeText(item.modeType) }}进入设备{{ (item?.device?.name ? (item?.device?.name) : (item.deviceSn || '')) }}</span>
            </el-tooltip>
          </div>
          <div>{{ item.passTime }}</div>
        </div>
      </div>
      <div v-if="!(attendanceList && attendanceList.length>0)" class="no-more">暂无数据...</div>
    </div>
  </div>
</template>


<script>
import {PassageRecordLogApi} from "@/api/nexus/passageRecordLog"

export default {
  components: {},
  data() {
    return {
      attendanceList: [],
      query: {
        pageNum: 1,
        pageSize: 30
      },
      passageRecordInterval: null
    };
  },
  created() {

  },
  mounted() {
    this.intervalPassageRecord();
  },
  destroyed() {
    this.passageRecordInterval && clearInterval(this.passageRecordInterval);
    this.passageRecordInterval = null;
  },
  methods: {
    intervalPassageRecord(){
      this.passageRecordInterval = setInterval(() => {
        this.getPassageRecord();
      },60000)
    },
    init(query) {
      this.query = Object.assign(this.query, query);
      this.getPassageRecord();
    },
    async getPassageRecord() {
      PassageRecordLogApi.page(this.query).then(response => {
        const {code, data} = response;
        if (code == 200) {
          this.attendanceList = data?.list || [];
        }
      })
    },
    modeTypeText(modeType) {
      if (modeType) {
        return modeType?.split('+')?.map(item => {
          switch (item) {
            case 'face':
              return '人脸';
            case 'fp':
              return '指纹';
            case 'palm':
              return '掌静脉';
            case 'password':
              return '密码';
            case 'card':
              return '卡片';
            case 'qrcode':
              return '二维码';
          }
        }).join('+') || '未知方式';
      }
      return '未知方式';
    },
  }
};
</script>